import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const ContactIcon = _ref => {
  let {
      size = "41",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("g", {
    id: "Icon-info"
  }, __jsx("g", {
    id: "Group-7"
  }, __jsx("path", {
    id: "Fill-1",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M31.8566 32.1474C28.9545 35.0507 25.0928 36.6484 20.9826 36.6484C16.8723 36.6484 13.0094 35.0507 10.1073 32.1474C7.17584 29.2159 5.56274 25.3542 5.56274 21.2734C5.56274 17.1901 7.17584 13.3284 10.1073 10.3982C13.0094 7.49616 16.8723 5.89844 20.9826 5.89844C25.0928 5.89844 28.9545 7.49616 31.8566 10.3982C34.7291 13.2708 36.3115 17.1312 36.3115 21.2734C36.3115 25.4132 34.7291 29.2748 31.8566 32.1474ZM33.6682 8.5865C30.2819 5.20016 25.777 3.33594 20.9826 3.33594C16.1882 3.33594 11.682 5.20016 8.29565 8.5865C4.87984 11.9998 3.00024 16.5059 3.00024 21.2734C3.00024 26.0384 4.87984 30.5446 8.29565 33.9591C11.682 37.3467 16.1882 39.2109 20.9826 39.2109C25.777 39.2109 30.2819 37.3467 33.6682 33.9591C37.0251 30.6035 38.874 26.0973 38.874 21.2734C38.874 16.447 37.0251 11.9408 33.6682 8.5865Z",
    fill: "#0039A6"
  }), __jsx("path", {
    id: "Fill-3",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M20.9365 11.0234C19.8756 11.0234 19.0146 11.8844 19.0146 12.9453C19.0146 14.0062 19.8756 14.8672 20.9365 14.8672C21.9987 14.8672 22.8584 14.0062 22.8584 12.9453C22.8584 11.8844 21.9987 11.0234 20.9365 11.0234Z",
    fill: "#0039A6"
  }), __jsx("path", {
    id: "Fill-5",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M20.9365 17.1094C20.0525 17.1094 19.335 17.8269 19.335 18.7109V30.2422C19.335 31.1263 20.0525 31.8438 20.9365 31.8438C21.8206 31.8438 22.5381 31.1263 22.5381 30.2422V18.7109C22.5381 17.8269 21.8206 17.1094 20.9365 17.1094Z",
    fill: "#0039A6"
  }))));
};
export default ContactIcon;